/**
 * @generated SignedSource<<4ad84ef0696da43eb9dcae70ba90e75b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LabelsCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LabelsCell_LabelsInlineEditCell">;
  readonly " $fragmentType": "LabelsCell";
};
export type LabelsCell$key = {
  readonly " $data"?: LabelsCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelsCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "LabelsCell",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "LabelsCell_LabelsInlineEditCell"
    }
  ],
  "type": "JiraLabelsField"
};

(node as any).hash = "5b6e5c66a83c717ab1a01b371fce907d";

export default node;
